// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDxBgG99PV-tJclUJvtS2Y-v4mwaL09Lc8",
    authDomain: "baypass-mstr.firebaseapp.com",
    databaseURL: "https://baypass-mstr.firebaseio.com",
    projectId: "baypass-mstr",
    storageBucket: "baypass-mstr.appspot.com",
    messagingSenderId: "339570529362",
    appId: "1:339570529362:web:c889c4df31b4bff0"
  },
  urlIframe: "http://itl.ec:8089/MicroStrategy/servlet/mstrWeb?evt=3140&src=mstrWeb.3140&documentID=11F3DC2345E0ED16A2A7E198A323BEA9&Server=74.208.85.231&Project=IT-MERCADOS&Port=0&share=1&hiddensections=header&uid=itmercados10&pwd=admin5ql"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
